/**
 * プロジェクトを人に渡す（第 1a 段・2026-10-21 core/handoff-1a）の日本語の文言。キーは en.transfer.ts と同じ（型で強制）。WHY は en.transfer.ts の冒頭。
 * 言い方: 「渡す / 受け取る / 持ち主」で通す（「移管」「譲渡」は使わない = 堅く、受託のクライアントに通じにくい）。
 */
import type { enTransfer } from './en.transfer';

export const jaTransfer: Record<keyof typeof enTransfer, string> = {
  'nav.transfer': '人に渡す',

  'transfer.title': 'このプロジェクトを人に渡す',
  'transfer.lead':
    'このプロジェクトを別の人に渡します（例: 作ってあげたクライアント）。相手に要るのは{product}のアカウントだけです（サーバーやコードの置き場の契約は要りません）。相手が受け取ると相手が持ち主になり、あなたはこのプロジェクトを開けなくなります。',
  'transfer.whatTitle': '相手が受け取るとどうなるか',
  'transfer.whatTitleIncoming': 'あなたが受け取るとどうなるか',
  'transfer.moves.title': '止まらずに新しい持ち主へ移るもの',
  'transfer.stays.title': 'あなたに残るもの',
  'transfer.stays.titleIncoming': '今の持ち主に残るもの',
  'transfer.redo.title': '渡す時に止める・外すもの',
  'transfer.item.games_and_urls': '公開中のアプリ・URL・公開した版の全部',
  'transfer.item.players': '利用者・保存したデータ・ログインの状態',
  'transfer.item.functions_and_data': 'Functions・データベース・保存したファイル',
  'transfer.item.public_keys': 'アプリに書き込むキー（pk_ で始まる）。止まりません',
  'transfer.item.custom_domains': '独自ドメイン（DNS の設定はそのまま）',
  'transfer.item.sign_in_settings': 'ログインの設定（Google・Discord・Apple）。新しい持ち主が自分のものに替えるのがおすすめです',
  'transfer.item.future_earnings': '渡した時からの売上と利用料',
  'transfer.item.future_usage': '渡した時からの利用料',
  'transfer.item.prepaid_balance': '前払い残高',
  'transfer.item.earnings_before': '渡す時までの売上（保留中の分も）',
  'transfer.item.unpaid_usage_before': '渡す時までの利用料の支払い',
  'transfer.item.payout_account': '売上の振込先',
  'transfer.item.secret_keys': 'サーバーだけで使うキー（sk_ で始まる）は使えなくなり、新しい持ち主に新しいキーを出します',
  'transfer.item.ai_connections': '今の持ち主がつないだAIエージェントは、このプロジェクトに触れなくなります',
  'transfer.item.store_keys': 'アプリストアのキーを外します（ストアのアカウントの持ち主のものなので）',
  'transfer.item.ads_txt': 'ads.txt の行を外します（今の持ち主の広告のアカウントが書かれているため）',
  'transfer.item.scheduled_mail': '利用者への予約したメールを止めます',
  'transfer.details.title': '新しい持ち主が自分のものに入れ直すもの',
  'transfer.details.secrets': 'Functions が使う値: {names}',
  'transfer.details.signIn': 'ログインの設定: {names}',
  'transfer.details.domains': '独自ドメイン（30 日以内に確かめ直してください）: {names}',
  'transfer.details.storeKeys': 'アプリストアのキー（渡す時に外します）: {names}',
  'transfer.invite.title': '新しい持ち主を招く',
  'transfer.invite.label': '相手のメールアドレス',
  'transfer.invite.help': '相手はこのアドレスで{product}にログイン（またはアカウントを作成）すると受け取れます。招きは {days} 日間有効です。',
  'transfer.invite.send': '招きを送る',
  'transfer.invite.sending': '送っています…',
  'transfer.invite.invalid': 'メールアドレスを最後まで入れてください。',
  'transfer.invite.self': 'あなた自身のメールアドレスです。受け取る人のアドレスを入れてください。',
  'transfer.invite.sent': '{email} に招きを送りました。',
  'transfer.noAccess': '渡した後は、このプロジェクトを開けなくなります。手伝い続けるときは、下の「共同作業者として残る」を選んでください（後で新しい持ち主に加えてもらうこともできます）。',
  'transfer.pending.title': '{email} さんが受け取るのを待っています',
  'transfer.pending.body': '相手が受け取るまで、持ち主はあなたのままです。招きの期限は {date} です。',
  'transfer.pending.cancel': '招きを取り消す',
  'transfer.cancel.confirmTitle': 'この招きを取り消しますか？',
  'transfer.cancel.confirmBody': '相手は受け取れなくなり、相手にメールが届きます。取り消した後で、また招けます。',
  'transfer.cancel.done': '招きを取り消しました。',
  'transfer.hold': 'あなたのアカウントで最近、安全に関わる変更（パスワードの変更など）がありました。プロジェクトを守るため、{date} から渡せます。',

  'transfer.in.title': '「{project}」を受け取る',
  'transfer.in.from': '{email} さんが、このプロジェクトをあなたに渡そうとしています。受け取ると、あなたが持ち主になります。',
  'transfer.in.money': '受け取った時から、このプロジェクトのサーバー代と利用料はあなたの前払い残高から払います。',
  'transfer.in.addFunds': '入金する',
  'transfer.in.expires': '期限は {date} です。',
  'transfer.in.accept': '受け取る',
  'transfer.in.accepting': '受け取っています…',
  'transfer.in.decline': '断る',
  'transfer.in.confirmTitle': '「{project}」の持ち主になりますか？',
  'transfer.in.confirmBody': 'すぐにあなたが持ち主になります。取り消せません。返すときは、あなたからもう一度渡します。',
  'transfer.in.declineTitle': 'このプロジェクトを断りますか？',
  'transfer.in.declineBody': '今の持ち主のままになり、今の持ち主にメールが届きます。',
  'transfer.in.declined': '断りました。何も変わっていません。',
  'transfer.in.done.title': '「{project}」の持ち主になりました',
  'transfer.in.done.keys': '新しい「サーバーだけで使うキー（sk_ で始まる）」です。表示は今だけなので、すぐにコピーしてください。前の持ち主のキーはもう使えません。',
  'transfer.in.done.redeploy': 'Functions をもう一度公開してください。新しいキーが入ります（{where}）。',
  'transfer.in.done.open': 'プロジェクトを開く',
  'transfer.in.wrongAccount': 'この受け渡しは {email} あてです。ログアウトして、そのアドレスでログインしてから、もう一度リンクを開いてください。',
  'transfer.in.notFound': 'この受け渡しのリンクは使えません。持ち主にもう一度招きを送ってもらってください。',
  'transfer.blocker.add_funds': '受け取る前に、前払い残高に入金してください。',
  'transfer.blocker.confirm_email': '先にメールアドレスを確かめてください。{product}から届いたメールのリンクを開くと済みます。',
  'transfer.blocker.account_closed': 'このアカウントは閉じているため、プロジェクトを受け取れません。',
  'transfer.blocker.project_unavailable': 'このプロジェクトは削除されたか、持ち主が替わったため、受け取れません。',
  'transfer.blocker.owner_security_hold': '今の持ち主のアカウントで最近、安全に関わる変更がありました。{date} から受け取れます。',
  'transfer.blocker.other': '今はこのプロジェクトを受け取れません。',
  'transfer.status.invited': 'この招きは受け取れます。',
  'transfer.status.accepted': 'このプロジェクトはもう受け取られています。',
  'transfer.status.declined': 'この招きは断られました。',
  'transfer.status.cancelled': '持ち主がこの招きを取り消しました。',
  'transfer.status.expired': 'この招きは期限が切れました。持ち主にもう一度送ってもらってください。',

  'transfer.banner.title': 'あなたあてのプロジェクトがあります',
  'transfer.banner.item': '{email} さんから「{project}」',
  'transfer.banner.review': '見る',

  'transfer.error.pending': 'このプロジェクトにはすでに開いている招きがあります。別の人を招くには、先に取り消してください。',
  'transfer.error.closed': 'この受け渡しはもう開いていません。',
  'transfer.error.funds': '先に前払い残高に入金してから受け取ってください。',
  'transfer.error.hold': 'アカウントで最近、安全に関わる変更があったため、今は渡せません。72 時間たってからもう一度お試しください。',
  'transfer.error.generic': 'うまくいきませんでした。少し待ってからもう一度お試しください。'
};
